module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "hidden-xs-only",
          attrs: {
            "slot": "activator",
            "small": "",
            "icon": ""
          },
          slot: "activator"
        }, on), [_c('v-icon', [_vm._v("settings")])], 1)]
      }
    }]),
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_vm._v(" "), _c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 overline py-2"
  }, [_vm._v("\n      Calendar settings\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-0",
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.options), function(option) {
    return _c('v-list', {
      key: option.value,
      attrs: {
        "dense": ""
      }
    }, [_c('v-subheader', {
      staticClass: "overline"
    }, [_vm._v(_vm._s(option.text))]), _vm._v(" "), _vm._l((option.items), function(item) {
      return _c('v-list-tile', {
        key: item.value,
        on: {
          "click": function($event) {
            return _vm.setItem(option.value, item.value)
          }
        }
      }, [(_vm.settings[option.value] === item.value) ? _c('v-list-tile-avatar', [_c('v-icon', [_vm._v("check")])], 1) : _c('v-list-tile-avatar', [_c('v-icon', [_vm._v("check_box_outline_blank")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.text))])], 1)], 1)
    })], 2)
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-953d8a7a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/CalendarSettings.vue
// module id = 1500
// module chunks = 9